import { Box, Typography } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';

import { CardAvatarDisabled } from '../route-error-boundary/assets/card-avatar-disabled';
import { routeErrorBoundaryStyles } from '../route-error-boundary/route-error-boundary.styles';

import theme from '@/theme/mui';

export const UnauthorizedPage = () => {
  const { t } = useTranslation();

  return (
    <ThemeProvider theme={theme}>
      <Box sx={routeErrorBoundaryStyles.container}>
        <Box sx={routeErrorBoundaryStyles.content}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <CardAvatarDisabled />
          </Box>
          <Typography variant="h5" sx={routeErrorBoundaryStyles.title}>
            {t('unauthorized.title')}
          </Typography>
          <Typography sx={routeErrorBoundaryStyles.message}>
            {t('unauthorized.message')}
          </Typography>
        </Box>
      </Box>
    </ThemeProvider>
  );
};
